<div class="settings-menu custom-container">
        <mat-tab-group class="tabs-container" [(selectedIndex)]="selectedTabIndex" (selectedTabChange)="onTabChange($event)" animationDuration="300ms">
    
        <mat-tab label="Usuarios" *ngIf="'ControlUsuarios' | permissionFilter">
        <ng-template mat-tab-label>
            <mat-icon>group</mat-icon>
            &nbsp;Usuarios
        </ng-template>
        <div class="tab-content">
            <userpage></userpage>
        </div>
        </mat-tab>

        <mat-tab label="Roles" *ngIf="'ControlRoles' | permissionFilter">
        <ng-template mat-tab-label>
            <mat-icon>key</mat-icon>
            &nbsp;Permisos
        </ng-template>
        <div class="tab-content">
            <rolePage></rolePage>
        </div>
        </mat-tab>

        <mat-tab label="Bitácora de sesiones">
        <ng-template mat-tab-label>
            <mat-icon>login</mat-icon>
            &nbsp;Bitácora de sesiones
        </ng-template>
        <div class="tab-content">
            <user-logsPage></user-logsPage>
        </div>
        </mat-tab>

        <mat-tab label="Alarmas de sistema" *ngIf="'ControlAlarmasSistema' | permissionFilter">
        <ng-template mat-tab-label>
            <mat-icon>alarm</mat-icon>
            &nbsp;Alarmas de sistema
        </ng-template>
        <div class="tab-content">
            <system-alarmsPage></system-alarmsPage>
        </div>
        </mat-tab>
        
    </mat-tab-group>
    </div>